import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettingsAdapter, formatWriteSettingsAdapts } from './format-write-settings.adapter';
import { ParquetFormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/parquet-format-write-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ParquetFormatWriteSettings),
    asynchronous: true,
    adapts: {
        ...formatWriteSettingsAdapts,
        enableVertiParquet: __IS_FABRIC_DPE__ ? '*' : undefined
    }
})
export class ParquetFormatWriteSettingsAdapter extends FormatWriteSettingsAdapter<
    ParquetFormatWriteSettings,
    Model.ParquetFormatWriteSettings
> {
    protected override async _toResource(model: ParquetFormatWriteSettings): Promise<Model.ParquetFormatWriteSettings> {
        const result: Model.ParquetFormatWriteSettings = FormatWriteSettingsAdapter.getCommonWriteSettingsProperties(
            Metamodel.modelFor(ParquetFormatWriteSettings).name
        );
        FormatWriteSettingsAdapter.toFormatWriteSettingsResource(model, result);
        if (__IS_FABRIC_DPE__) {
            result.enableVertiParquet = ValueAdapter.toResource(model, ParquetFormatWriteSettings.VERTI_PARQUET);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.ParquetFormatWriteSettings,
        copySink: CopySink
    ): Promise<ParquetFormatWriteSettings> {
        const result = FormatWriteSettingsAdapter.createWriteSettingsWithCommonProperties(
            ParquetFormatWriteSettings.MODEL,
            copySink
        ) as ParquetFormatWriteSettings;
        FormatWriteSettingsAdapter.toFormatWriteSettingsModel(resource, result);
        if (__IS_FABRIC_DPE__) {
            ValueAdapter.toModel(result, ParquetFormatWriteSettings.VERTI_PARQUET, resource.enableVertiParquet);
        }
        return result;
    }
}
